import React, { useEffect, useState } from "react";
import "@devexpress/dx-react-grid-bootstrap4/dist/dx-react-grid-bootstrap4.css";
import "open-iconic/font/css/open-iconic-bootstrap.css";
import {
  Grid,
  TableHeaderRow,
  TableTreeColumn,
  Table,
  TableColumnResizing,
} from "@devexpress/dx-react-grid-bootstrap4";
import { CustomTreeData, TreeDataState } from "@devexpress/dx-react-grid";

const TableComponent = ({ ...restProps }) => (
  <Table.Table {...restProps} className="table-striped" />
);

export default function APLDataGrid({
  period,
  data,
  columns,
  columnExtensions,
}) {
  const [defaultColumnWidths] = useState(columnExtensions);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    var parentRows = data.filter((r) => r.parentId === null);
    parentRows.forEach((row) => {
      row.childRows = data.filter((r) => r.parentId === row.id);
    });
    setRows(parentRows);
  }, [data]);

  const getChildRows = (row, rootRows) => {
    return row ? row.childRows : rootRows;
  };

  const totalHours = period
    ? Math.round(
        ((new Date(period.to) - new Date(period.from)) /
          (7 * 24 * 60 * 60 * 1000)) *
          period.hoursPerWeek
      )
    : 0;

  const TableRow = ({ row, ...restProps }) => {
    const rowColorAmount = (row.hours / totalHours) * 100;
    return (
      <Table.Row
        {...restProps}
        style={{
          background: `linear-gradient(to right, #90EE90  ${rowColorAmount}%,#90EE90  ${rowColorAmount}%,#90EE90   ${rowColorAmount}%,#E4E4E4 ${rowColorAmount}%,#E4E4E4 100%)`,
        }}
      />
    );
  };

  return (
    <Grid rows={rows} columns={columns}>
      <TreeDataState />
      <CustomTreeData getChildRows={getChildRows} />

      <Table tableComponent={TableComponent} rowComponent={TableRow} />
      <TableColumnResizing defaultColumnWidths={defaultColumnWidths} />
      <TableHeaderRow />

      <TableTreeColumn for="name" visible="true" />
    </Grid>
  );
}
